import script from "./contentTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./contentTitle.vue?vue&type=script&setup=true&lang=js"

import "./contentTitle.vue?vue&type=style&index=0&id=ff48d340&lang=scss"

const __exports__ = script;

export default __exports__